import { call, put } from 'redux-saga/effects'
import { ACTIONS, APIS, KEYS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* ssoinitiate<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.AUTH.SSO_INITIATE, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e.message, status_code: 400, success: false })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({ message: e?.message || 'SSO initiation failed', status_code: 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'ssoinitiate', action: action?.type })
    }
}

export function* login<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.AUTH.LOGIN, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            localStorage.setItem(KEYS.AUTH_ACCESS, resp.data.access_token)
            localStorage.setItem(KEYS.AUTH_REFRESH, resp.data.refresh_token)
            yield put({ type: ACTIONS.USER.LOGIN, payload: { user: resp.data, accessToken: resp.data.access_token, refreshToken: resp.data.refresh_token, isAuthenticated: true, permissions: resp.data.permissions } })
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Login failed',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'login', action: action?.type })
    }
}

export function* logout<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.AUTH.LOGOUT, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            localStorage.removeItem(KEYS.AUTH_ACCESS)
            localStorage.removeItem(KEYS.AUTH_REFRESH)
            localStorage.removeItem('persist:root')
            yield put({ type: ACTIONS.USER.LOGOUT, payload: {} })
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Logout failed',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'logout', action: action?.type })
    }
}

export function* registerinitiate<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.AUTH.LOGIN, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Registration initiation failed',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'registerinitiate', action: action?.type })
    }
}
export function* register<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.POST, APIS.AUTH.REGISTRATION, data)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // const errorData = { message: e?.data?.message ?? 'An error occurred', status_code: e?.status ?? 400, success: false }
        // action?.onError(errorData)
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Registration failed',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'register', action: action?.type })
    }
}

export function* updateUser<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.PUT, APIS.AUTH.UPDATE_USER((action.payload as any)?.user_literal ?? ''), data)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            yield put({ type: ACTIONS.USER.UPDATE_USER, payload: { user: resp.data.data } })
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // const errorData = { message: e?.data?.message ?? 'An error occurred', status_code: e?.status ?? 400, success: false }
        // action?.onError(errorData)
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'An error occurred',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'updateUser', action: action?.type })
    }
}
export function* forgotPassword(action: any): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.POST, APIS.AUTH.FORGOT_PASSWORD, data)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.callbackSuccess?.(resp.data.data)
        } else {
            action?.callbackError?.(resp.data.data.statusMessage)
        }
    } catch (e: any) {
        // action?.callbackError?.(e?.data ?? e)
        // ✅ CHANGED: Added null check and fallback error object
        action?.callbackError?.(e?.data ?? { message: e?.message || 'An error occurred', status_code: e?.status || 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'forgotPassword', action: action?.type })
    }
}
export function* resetPassword(action: any): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.POST, APIS.AUTH.RESET_PASSWORD, data)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.callbackSuccess?.(resp.data.data)
        } else {
            action?.callbackError?.(resp.data.data.statusMessage)
        }
    } catch (e: any) {
        // action?.callbackError?.(e?.data ?? e)
        // ✅ CHANGED: Added null check and fallback error object
        action?.callbackError?.(e?.data ?? { message: e?.message || 'An error occurred', status_code: e?.status || 400, success: false })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'resetPassword', action: action?.type })
    }
}

export function* ssoverify<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.AUTH.SSO_VERIFY, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        //console.log('SSO Verify Error:', e)
        // action?.onError({ message: e?.data?.message ? e?.data?.message : e?.response?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.response?.data?.message || e?.message || 'SSO verification failed',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'ssoverify', action: action?.type })
    }
}
export function* getUpdateRequestedUsers<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.USERS.GET_UPDATE_REQUESTED_USERS, action.payload, false, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Failed to get update requested users',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getUpdateRequestedUsers', action: action?.type })
    }
}
export function* updateRequestedUserAction<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.USERS.UPDATE_REQUESTED_USER_ACTION, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Failed to update requested user action',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'updateRequestedUserAction', action: action?.type })
    }
}
export function* getBusinessOwnerDetails<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.USERS.GET_BUSINESS_OWNER_DETAILS((action.payload as any).literal), { multi_rows: true }, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            localStorage.setItem(KEYS.BUSINESS_OWNER, JSON.stringify(resp.data.data))
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Failed to get business owner details',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getBusinessOwnerDetails', action: action?.type })
    }
}

export function* getTestOpsCopilotToken<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.USERS.GET_TESTOPS_COPILOT_TOKEN, { access_token: localStorage.getItem(KEYS.AUTH_ACCESS_TOKEN) })
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            localStorage.setItem(KEYS.BUSINESS_OWNER, JSON.stringify(resp.data.data))
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Failed to get test ops copilot token',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getTestOpsCopilotToken', action: action?.type })
    }
}
export function* updateProfile<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    const { literal, ...data } = action.payload as { literal: string; [key: string]: any }

    try {
        const resp = yield call(CallApi.PUT, APIS.USERS.UPDATE_USER(literal), data)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            localStorage.setItem(KEYS.BUSINESS_OWNER, JSON.stringify(resp.data.data))
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Failed to update profile',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'updateProfile', action: action?.type })
    }
}
export function* setLanguage<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.PUT, APIS.USERS.SET_LANGUAGE, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({ message: e?.data?.message, status_code: e?.status, success: false })
        // ✅ CHANGED: Added optional chaining to all error properties
        action?.onError({
            message: e?.data?.message || e?.message || 'Failed to set language',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'setLanguage', action: action?.type })
    }
}
